export default Array.prototype.intersection = function (arr2) {
    return this.filter(element => arr2.find(e => e.includes(element)));
};